export default __webpack_public_path__ + "static/trustify-size-s-bd9f52b41683016b618a60424e23bf08.png";